import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import './CorporateLayoutWrapper.css';
// import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo.png";
import { login_list, doLoginRes } from '../../action/LoginAction';
import { createRegister, doRegisterRes } from '../../action/RegisterAction';
import { menuCategory, doMenuCategoryRes } from '../../action/MenuCategoryAction';
import { showProductList, doProductListingRes } from '../../action/ProductListAction';
import { showCorporateCartList, doCorporateCartListRes } from '../../action/CorporateCartListAction';
import { corporateProductRemove, doCorporateProductRemoveRes } from '../../action/CorporateProductRemoveAction';
import { showProfile, doProfileDetailsListRes } from '../../action/ProfileDetailsListAction'
import { searchData, doSearchingListRes } from '../../action/SearchingListAction'
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import PropTypes from 'prop-types';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import LoginRegister from '../../container/LoginRegister/LoginRegister'
import LoaderSpinner from '../loader';
import AppIcon from '../../assets/images/appIcon/app-icon.png';

import {
    isAndroid,
    isIOS
} from "react-device-detect";

import ReactGA from 'react-ga';

// import loaderImg from '../../assets/images/loader-example.gif';
// import Loader from 'react-loader-advanced';
// import { AsyncTypeahead } from 'react-bootstrap-typeahead';
class CorporateLayoutWrapper extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoader: false,
            isSubmited: false,
            isLoginSubmited: false,
            loginModalPopup: false,
            email: '',
            password: '',
            nameRegister: '',
            emailRegister: '',
            passwordRegister: '',
            userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
            menuCategoryList: [],
            cartViewData: [],
            localUserName: localStorage.getItem('userName'),
            cartCheck: false,
            removeCart: false,
            searchModal: false,
            searchTableData: [],
            options: [],
            mobileView: false,
            TopMobileView: false,
            showBanner: true,
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    loginFormShow() {
        this.setState({
            loginModalPopup: true
        })
    }

    onCloseModal = () => {
        this.setState({
            loginModalPopup: false
        })
    }

    openMobileView() {
        this.setState({
            mobileView: !this.state.mobileView
        })
    }

    closeMobileView = () => {
        this.setState({
            mobileView: false
        })
    }

    openTopMobileView() {
        this.setState({
            TopMobileView: !this.state.TopMobileView
        })
    }

    componentDidMount() {
        const data = {}
        this.props.menuCategory(data)
        const cartData = {
            user_id: localStorage.getItem('userId')

        }
        this.props.showCorporateCartList(cartData)

    }

    getValue = (e) => {
        this.setState({
            loginModalPopup: e
        })
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.doLoginRes && nextProps.doLoginRes.user) {
            if (nextProps.doLoginRes.user && nextProps.doLoginRes.user.LoginRes) {
                if (nextProps.doLoginRes.user.LoginRes && nextProps.doLoginRes.user.LoginRes.result === true) {
                    localStorage.setItem('userId', nextProps.doLoginRes.user.LoginRes.user_id);
                    localStorage.setItem('userName', nextProps.doLoginRes.user.LoginRes.name);
                    this.setState({
                        userName: nextProps.doLoginRes.user.LoginRes.name,
                    })
                }
            }
        }

        if (nextProps.doRegisterRes && nextProps.doRegisterRes.user) {
            if (nextProps.doRegisterRes.user && nextProps.doRegisterRes.user.RegisterRes) {
                if (nextProps.doRegisterRes.user.RegisterRes && nextProps.doRegisterRes.user.RegisterRes.result === true) {
                    this.setState({
                        isLoader: false,
                        loginModalPopup: false,
                    })
                } else {
                    this.setState({
                        isLoader: false,
                        loginModalPopup: false,
                    })
                }
            }
        }

        if (nextProps.doMenuCategoryRes && nextProps.doMenuCategoryRes.user) {
            if (nextProps.doMenuCategoryRes.user && nextProps.doMenuCategoryRes.user.MenuCategoryRes) {
                if (nextProps.doMenuCategoryRes.user.MenuCategoryRes && nextProps.doMenuCategoryRes.user.MenuCategoryRes.result === true) {
                    for (let item of nextProps.doMenuCategoryRes.user.MenuCategoryRes.category) {
                        item['show'] = false;
                    }

                    this.setState({
                        menuCategoryList: nextProps.doMenuCategoryRes.user.MenuCategoryRes.category
                    })
                }
            }
        }

        if (nextProps.doCorporateCartListRes && nextProps.doCorporateCartListRes.user) {
            if (nextProps.doCorporateCartListRes.user && nextProps.doCorporateCartListRes.user.CorporateCartListRes) {
                if (nextProps.doCorporateCartListRes.user.CorporateCartListRes && nextProps.doCorporateCartListRes.user.CorporateCartListRes.result === true) {
                    if (nextProps.doCorporateCartListRes.user.CorporateCartListRes.cart === null) {
                        this.setState({
                            cartViewData: [],
                            cartCheck: false
                        })
                    } else {
                        this.setState({
                            cartViewData: nextProps.doCorporateCartListRes.user.CorporateCartListRes.cart,
                            cartCheck: false
                        })
                    }
                }
            }
        }

        if (nextProps.doCorporateProductRemoveRes && nextProps.doCorporateProductRemoveRes.user) {
            if (nextProps.doCorporateProductRemoveRes.user && nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes) {
                if (nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes && nextProps.doCorporateProductRemoveRes.user.CorporateProductRemoveRes.results === true && this.state.removeCart === true) {

                    if (window.location.pathname === '/checkout') {
                        window.location.href = '/checkout'
                    }
                    this.setState({
                        cartCheck: true,
                        removeCart: false
                    }, () => {
                        if (this.state.cartCheck) {
                            const cartData = {
                                user_id: localStorage.getItem('userId')
                            }
                            this.props.showCorporateCartList(cartData)
                        }
                    })
                }
            }
        }

        if (nextProps.doProfileDetailsListRes && nextProps.doProfileDetailsListRes.user) {
            if (nextProps.doProfileDetailsListRes.user && nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes) {
                if (nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes && nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.result === true) {
                    localStorage.setItem('userName', nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.profile.first_name);
                    this.setState({
                        // user_id: nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.profile.user_id,
                        userName: nextProps.doProfileDetailsListRes.user.ProfileDetailsListRes.profile.first_name,

                        // showProfile: false,
                    })
                }
            }
        }

        if (nextProps.doSearchingListRes && nextProps.doSearchingListRes.user) {
            if (nextProps.doSearchingListRes.user && nextProps.doSearchingListRes.user.SearchingListRes) {
                if (nextProps.doSearchingListRes.user.SearchingListRes && nextProps.doSearchingListRes.user.SearchingListRes.results === true) {
                    this.setState({
                        searchTableData: nextProps.doSearchingListRes.user.SearchingListRes.data
                    }, () => {
                        let searchProp = []
                        if (this.state.searchTableData) {
                            for (let item of this.state.searchTableData) {
                                searchProp.push({
                                    // avatar_url: item.photo,
                                    id: item.product_id,
                                    name: item.name,
                                    item: item
                                })
                                this.setState({
                                    options: searchProp
                                })
                            }
                        }
                    })
                }
            }
        }
    }

    logOut = () => {
        localStorage.clear();
        window.location.href = '/';
    }

    removetItemCart = (id) => {
        const data = {
            cart_id: id
        }
        this.setState({
            removeCart: true
        })
        this.props.corporateProductRemove(data)
    }

    manMenu = (manItem) => {
        window.location.href = '/menu-subcatrgory/' + manItem.id + '/' + manItem.slug
        this.props.history.push('/menu-subcatrgory/' + manItem.id + '/' + manItem.slug, {
            productCategoryData: manItem
        })
        if (manItem.sub_cat.length === 0) {
            window.location.href = '/product/' + manItem.id + '/0/' + manItem.slug

            this.props.history.push('/product/' + manItem.id + '/0/' + manItem.slug, {
                sub_id: 0,
                cat_id: manItem.id
            })
        }
    }

    subMenu = (subItem) => {
        if (subItem.type === "customize") {
            if (subItem.sub_id === "10") {
                window.location.href = '/productcustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === "14") {
                window.location.href = '/productmobilecustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '11') {
                window.location.href = '/productwomencustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '17') {
                window.location.href = '/productkidscustomize/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            }
            if (subItem.sub_id === '13' || subItem.sub_id === '12') {
                window.location.href = '/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
                this.props.history.push('/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug, {
                    sub_id: subItem.sub_id,
                    cat_id: subItem.cat_id
                })
            }
        } else {
            window.location.href = '/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug
            this.props.history.push('/product/' + subItem.cat_id + '/' + subItem.sub_id + '/' + subItem.slug, {
                sub_id: subItem.sub_id,
                cat_id: subItem.cat_id
            })
        }

    }

    showMenu = (i) => {
        let data = this.state.menuCategoryList;
        for (let v = 0; v < data.length; v++) {
            if (v === i) {
                data[v].show = true
            } else {
                data[v].show = false
            }
        }
        this.setState({
            menuCategoryList: [...data]
        })
    }

    searchOption = () => {
        this.setState({
            searchModal: !this.state.searchModal
        })
    }

    searchItem = (e) => {
        const searchingData = {
            keyword: e.target.value
        }
        this.props.searchData(searchingData)
    }



    handleOnSearch = (e) => {
        // onSearch returns the string searched and if
        // the values are cached. If the values are cached
        // "cached" contains the cached values, if not, returns false

        const searchingData = {
            keyword: e
        }
        this.props.searchData(searchingData)
    }

    handleOnSelect = item => {
        if (item.item) {
            console.log('ujk451', item.item)
        }
        // if(item.item.product_type === "simple" || item.item.product_type === "Simple"){

        //     window.location.href ='/productview/'+item.item.slug
        //     this.props.history.push('/productview/'+item.item.slug, {
        //         product_type: item.item.product_type,
        //         product_id:item.item.product_id,
        //         is_varient: item.item.is_varient,
        //         sub_cat_id: item.item.sub_cat_id
        //     })
        // }

        // if(item.item.product_type === "customize"){
        //     if(item.item.sub_cat_id === "10"){
        //         window.location.href = '/productcustomize/'+item.item.slug
        //     } 
        //     if(item.item.sub_cat_id === "14"){
        //         window.location.href = '/productmobilecustomize/'+item.item.slug
        //     }
        //     if(item.item.sub_cat_id === '11'){
        //         window.location.href = '/productwomencustomize/'+item.item.slug
        //     }
        //     if(item.item.sub_cat_id === '17'){
        //         window.location.href = '/productkidscustomize/'+item.item.slug
        //     }
        //     if(item.item.sub_cat_id === '12'){
        //         window.location.href ='/productkeycustomize/'+item.item.slug
        //         this.props.history.push('/productkeycustomize/'+item.item.slug, {
        //                 product_type: item.item.product_type,
        //                 product_id:item.item.product_id,
        //                 is_varient: item.item.is_varient
        //             })
        //     }
        //     if(item.item.sub_cat_id === '13'){
        //         window.location.href ='/productcupcustomize/'+item.item.slug
        //         this.props.history.push('/productcupcustomize/'+item.item.slug, {
        //             product_type: item.item.product_type,
        //             product_id:item.item.product_id,
        //             is_varient: item.item.is_varient
        //         })
        //     }
        // }

    }

    handleOnFocus = () => {
    }

    hideBanaer = () => {
        this.setState({
            showBanner: false,
        });
        localStorage.setItem('topPopUp', true)
    }


    render() {
        const { loginModalPopup } = this.state;
        // const filterBy = () => true;

        const closeIcon = (

            <i className="fa fa-times closeIconbg" aria-hidden="true"></i>
        );

        return (
            <div className="styles fixed-top">
                <React.Fragment>
                    {
                        !localStorage.getItem("topPopUp") &&
                        <div>
                            {
                                (isIOS) &&

                                <div>
                                    {
                                        (this.state.showBanner) &&
                                        <div className="mysmartbannerios mysmartbanner-ios mysmartbanner-top">
                                            <div className="smartbanner-container">
                                                <button type="button" className="smartbanner-close" aria-label="close" onClick={this.hideBanaer}>×</button><span className="smartbanner-icon" style={{ backgroundImage: 'url(' + AppIcon + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }}></span>
                                                <div className="smartbanner-info">
                                                    <div className="smartbanner-title">Stylecabbie - Your Style Driver</div>
                                                    <div className="smartbanner-author"></div>
                                                    <div className="smartbanner-description">Free - On the App Store</div>
                                                </div>
                                                <div className="smartbanner-wrapper"><a href="https://apps.apple.com/us/app/stylecabbie/id1510905562" className="smartbanner-button"><span className="smartbanner-button-text">View</span></a></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                (isAndroid) &&
                                <div>
                                    {
                                        (this.state.showBanner) &&
                                        <div className="mysmartbanner mysmartbanner-android mysmartbanner-top">
                                            <div className="smartbanner-container">
                                                <button type="button" className="smartbanner-close" aria-label="close" onClick={this.hideBanaer}>×</button><span className="smartbanner-icon" style={{ backgroundImage: 'url(' + AppIcon + ')', backgroundSize: '100%', backgroundPosition: "center", backgroundRepeat: "no-repeat" }}></span>
                                                <div className="smartbanner-info">
                                                    <div className="smartbanner-title">Stylecabbie - Your Style Driver</div>
                                                    <div className="smartbanner-author"></div>
                                                    <div className="smartbanner-description">Free - In Google Play</div>
                                                </div>
                                                <div className="smartbanner-wrapper"><a href="https://play.google.com/store/apps/details?id=com.stylecabbie" className="smartbanner-button"><span className="smartbanner-button-text">View</span></a></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <header className="header header-clr">
                        <div className="header-top header-menu1">
                            <div className="container">
                                <div className="topHeaderRight header-left header-dropdowns">
                                    <div>
                                        <Link to={"/corporate-tab"}>
                                            <p className="uppercase header-top-menu"><strong className="str header-top-menu">Get your corporate deals</strong></p>
                                        </Link>

                                    </div>
                                    {/* End .header-dropown */}
                                    <div className="dropdown compare-dropdown">
                                        <a href="/" className="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">

                                        </a>
                                        {/* End .dropdown-menu  */}
                                    </div>
                                    {/* End .dropdown  */}
                                </div>
                                {/* End .header-left  */}

                                <div className="topHeaderLeft">
                                    <div className="top-menu-view active dropdown-toggle float-right" onClick={() => this.openTopMobileView()}>Quick Links</div>
                                    <div className="header-dropdown dropdown-expanded float-right">
                                        {
                                            this.state.TopMobileView ?
                                                <div className="header-menu manu2 top-links">
                                                    <ul>
                                                        <li><a className='header-top-menu' href="https://blog.stylecabbie.com">Blogs </a></li>
                                                        <li><a className='header-top-menu' href="/aboutus">About Us </a></li>
                                                        <li><a className='header-top-menu' href="/ourstory">Our Story</a></li>
                                                        <li><a className='header-top-menu' href="/contacts">Contact </a></li>
                                                        <li><a className='header-top-menu' href="/covid19">COVID-19</a></li>
                                                    </ul>
                                                </div> : <div className="header-menu manu2 top-menu1">
                                                    <ul>
                                                        <li><a className='header-top-menu' href="https://blog.stylecabbie.com">Blogs </a></li>
                                                        <li><a className='header-top-menu' href="/aboutus">About Us </a></li>
                                                        <li><a className='header-top-menu' href="/ourstory">Our Story</a></li>
                                                        <li><a className='header-top-menu' href="/contacts">Contact </a></li>
                                                        <li><a className='header-top-menu' href="/covid19">COVID-19</a></li>
                                                    </ul>
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* End .container */}
                        </div>
                        {/* End .header-top */}

                        <div className="header-middle sticky-header">
                            <div className="container Manu-container">
                                <div className="header-left">
                                    <Link to={"/"} className="logo">
                                        <img src={logo} alt="Porto Logo" width="125" height="91" />
                                    </Link>
                                    <nav className="main-nav shedo">
                                        <ul className="menu sf-arrows">
                                            {/* <li className="active"><a href="/">Home</a></li> */}
                                            {
                                                this.state.menuCategoryList && this.state.menuCategoryList.map((item, i) => (
                                                    <li key={i}>
                                                        <div lowercase='sf-with-ul' className={item.sub_cat.length > 0 ? "sf-with-ul" : 'sf-with'} onClick={() => this.manMenu(item)}> {item.cat_name}
                                                        </div>
                                                        {item.sub_cat.length > 0 &&
                                                            <div className="megamenu megamenu-fixed-width mens scroll-cart">
                                                                <div className="row">
                                                                    <div className="col-lg-8">
                                                                        <div className="row">
                                                                            <div className="col-lg-6">
                                                                                <ul>
                                                                                    {item.sub_cat.map((subItem, s) => (
                                                                                        <li key={s}>
                                                                                            <div className="sub-menu" onClick={() => this.subMenu(subItem, item.cat_name)}>{subItem.name}
                                                                                            </div>
                                                                                        </li>
                                                                                    ))}

                                                                                </ul>
                                                                            </div>
                                                                            {/* End .col-lg-6 */}

                                                                        </div>
                                                                        {/* End .row */}
                                                                    </div>
                                                                    {/* End .col-lg-8 */}
                                                                </div>
                                                            </div>
                                                            //  End .megamenu 
                                                        }

                                                    </li>

                                                ))
                                            }


                                        </ul>
                                    </nav>
                                </div>
                                {/* End .header-left  */}

                                <div className="header-right">

                                    <div className="header-search">
                                        <span className="search-toggle" role="button" ><i className="icon-search lr-cursor-pointer" onClick={() => this.searchOption()}></i></span>

                                        {this.state.searchModal &&
                                            <div>

                                                <div className="header-search-wrapper show hover-search">

                                                    <div style={{ width: 440 }}>
                                                        <ReactSearchAutocomplete
                                                            items={this.state.options}
                                                            onSearch={(e) => this.handleOnSearch(e)}
                                                            onSelect={(e) => this.handleOnSelect(e)}
                                                            onFocus={() => this.handleOnFocus()}
                                                            autoFocus
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                    </div>

                                    {/* End .header-search */}
                                    <button className="mobile-menu-toggler active" type="button">
                                        <i className="icon-menu" onClick={() => this.openMobileView()}></i>
                                    </button>

                                    <div className="header-contact ryt">
                                        <div className="login-content">
                                            {
                                                this.state.userName !== '' ?
                                                    <div className="dropdown cart-dropdown">
                                                        <span className="lr-cursor-pointer">
                                                            {this.state.userName}
                                                        </span>
                                                        <div className="dropdown-menu menu-dropdown" >
                                                            <div className="dropdownmenu-wrapper">
                                                                <div className="dropdown-cart-products">
                                                                    <Link to="/profile-update"><span className="product-details dropdown-profile p-2">My Account</span></Link>
                                                                    {/* <Link to="/change-password"><span className="product-details dropdown-profile p-2">Change Password</span></Link> */}
                                                                    <span className="product-details dropdown-profile p-2" onClick={() => this.logOut()}>LogOut</span>

                                                                    {/* End .products */}
                                                                </div>
                                                                {/* End .cart-product */}
                                                            </div>
                                                            {/* End .dropdownmenu-wrapper */}
                                                        </div>
                                                        {/* End .dropdown-menu */}
                                                    </div>
                                                    :
                                                    <span className="lr-cursor-pointer" onClick={() => this.loginFormShow()}>
                                                        LOGIN / REGISTER
                                                    </span>}
                                        </div>
                                    </div>
                                    {/* End .header-contact */}

                                    <div className="dropdown cart-dropdown cdd">
                                        {/* <span className="span-Cart cart-span">CART /  0.00</span> */}

                                        <a href="/" className="dropdown-toggle cart_spn" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static">
                                            {localStorage.getItem('userId') ?
                                                <span className="cart-count">{this.state.cartViewData.length}</span> : <span className="cart-count">0</span>}
                                        </a>

                                        {this.state.userName !== '' ?
                                            <div className="dropdown-menu scroll-cart" >
                                                <div className="dropdownmenu-wrapper">
                                                    <div className="dropdown-cart-products">
                                                        {this.state.cartViewData && this.state.cartViewData.length === 0 ? 'No data found' : this.state.cartViewData.map((item, i) => (
                                                            <div className="product" key={i}>
                                                                <div className="product-details">
                                                                    <div>
                                                                        <h4 className="product-title">
                                                                            <span className="title-fnt-clr">{item.name}</span>
                                                                        </h4>

                                                                        {
                                                                            (item.color === undefined && item.color === null && item.size === null && item.sleeve === null) ? '' : (item.color !== '' && item.size !== '' && item.sleeve !== '' && item.color !== undefined) &&
                                                                                <span className="fnt-size">Color : {item.color}, Size: {item.size}, sleeve : {item.sleeve}
                                                                                </span>
                                                                        }
                                                                        {
                                                                            ((item.brand === null && item.model === null) || (item.brand === "undefined" && item.model === "undefined") || (item.brand === undefined && item.model === undefined)) ? '' : (item.brand !== '' && item.model !== '') &&
                                                                                <span className="fnt-size">Brand : {item.brand}, Model: {item.model}
                                                                                </span>
                                                                        }
                                                                    </div>

                                                                    <span className="cart-product-info">
                                                                        <span className="cart-product-qty">{item.qty}</span>
                                                                        x <i className="fa fa-inr"></i>{item.price}
                                                                    </span>
                                                                </div>
                                                                {/* End .product-details */}

                                                                <figure className="product-image-container">
                                                                    <span className="product-image">
                                                                        {

                                                                        }
                                                                        <img src={(item.thumbnail || item.thumbnail_back || item.thumbnail_pocket)} alt="product" />
                                                                    </span>
                                                                    <div className="btn-remove pointer" title="Remove Product" onClick={() => this.removetItemCart(item.id)}><i className="icon-cancel"></i></div>
                                                                </figure>
                                                            </div>
                                                        ))}

                                                        {/* End .product  */}
                                                    </div>
                                                    {/* End .cart-product */}

                                                    {/* <div class="dropdown-cart-total">
                                                            <span>Total</span>

                                                            <span class="cart-total-price">$134.00</span>
                                                        </div> */}
                                                    {/* End .dropdown-cart-total */}
                                                    {this.state.cartViewData && this.state.cartViewData.length > 0 &&
                                                        <div className="dropdown-cart-action">
                                                            <a href="/corporate-product-cart" className="btn">View Cart</a>
                                                            <a href="/corporate-product-cart" className="btn">Checkout</a>
                                                        </div>
                                                    }
                                                    {/* End .dropdown-cart-total */}
                                                </div>
                                                {/* End .dropdownmenu-wrapper */}
                                            </div> : <div className="dropdown cart-dropdown">
                                                <span className="lr-cursor-pointer">
                                                    {this.state.userName}
                                                </span>
                                                <div className="dropdown-menu menu-dropdown" >
                                                    <div className="dropdownmenu-wrapper">
                                                        <div className="dropdown-cart-products">
                                                            <span className="product-details dropdown-profile p-2" onClick={() => this.loginFormShow()}> LOGIN / REGISTER</span>


                                                            {/* End .products */}
                                                        </div>
                                                        {/* End .cart-product */}
                                                    </div>
                                                    {/* End .dropdownmenu-wrapper */}
                                                </div>
                                                {/* End .dropdown-menu */}
                                            </div>}
                                        {/* End .dropdown-menu */}


                                    </div>
                                    {/* End .dropdown  */}
                                </div>
                                {/* End .header-right  */}
                            </div>
                            {/* End .container  */}
                        </div>
                        {/* End .header-middle  */}
                    </header>
                    {/* End .header */}

                    <Modal open={loginModalPopup} onClose={this.onCloseModal} closeIcon={closeIcon}>
                        <LoginRegister getValue={this.getValue} />

                    </Modal>
                    <div className="mobile-menu-overlay"></div>
                    {this.state.mobileView &&

                        <div className="mobile-menu-container">
                            <div className="mobile-menu-wrapper">
                                <span className="mobile-menu-close"><i className="icon-cancel" onClick={() => this.closeMobileView()}></i></span>
                                <nav className="mobile-nav">
                                    <ul className="mobile-menu">



                                        {
                                            this.state.menuCategoryList && this.state.menuCategoryList.map((item, i) => (
                                                // <li className="active"><a href="/">Home</a></li>
                                                <li key={i} >
                                                    <span className="mobie_view_a" onClick={() => this.manMenu(item)}>{item.cat_name}</span>
                                                    {item.sub_cat.length > 0 && (!item.show ?
                                                        <span onClick={() => this.showMenu(i)} className="mmenu-btn"></span> :
                                                        <span onClick={() => this.showMenu(-1)} className="mmenu-btn mmenu-btn-2"></span>)
                                                    }
                                                    {
                                                        item.sub_cat.length > 0 &&
                                                        <div>

                                                            {
                                                                item.show ?
                                                                    <ul>
                                                                        {item.sub_cat.map((subItem, s) => (
                                                                            <li key={s} onClick={() => this.subMenu(subItem, item.cat_name)}><span className="mobie_view_a">{subItem.name}</span></li>
                                                                        ))}
                                                                    </ul> : ''
                                                            }
                                                        </div>
                                                    }

                                                </li>))


                                        }
                                        {
                                            localStorage.getItem('userId') ?
                                                <div>
                                                    <li>
                                                        <Link to="/profile-update"><span className="product-details dropdown-profile p-2 mobie_view_a">My Account</span></Link>
                                                    </li>
                                                    <li>
                                                        <span className="product-details dropdown-profile p-2 mobie_view_a logout" onClick={() => this.logOut()}>LogOut</span>
                                                    </li>
                                                </div> : <li><span className="mobie_view_a dropdown-profile p-2 logout" onClick={() => this.loginFormShow()}> LOGIN / REGISTER</span></li>
                                        }


                                    </ul>

                                </nav>
                                {/* End mobile-nav */}

                                <div className="social-icons">

                                    <a href="https://www.facebook.com/stylecabbie" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                                    <a href="https://www.instagram.com/stylecabbie/" className="social-icon" target="_blank" rel="noopener noreferrer"><i className="icon-instagram"></i></a>
                                </div>
                                {/* End .social-icons */}
                            </div>
                            {/* End .mobile-menu-wrapper */}
                        </div>
                    }
                    {/* End .mobile-menu-container */}
                    <LoaderSpinner />
                </React.Fragment>
            </div>
        );
    }
}

CorporateLayoutWrapper.propTypes = {
    doLoginRes: PropTypes.any,
    doRegisterRes: PropTypes.any,
    doMenuCategoryRes: PropTypes.any,
    doCorporateCartListRes: PropTypes.any,
    doProductListingRes: PropTypes.any,
    doCorporateProductRemoveRes: PropTypes.any,
    doProfileDetailsListRes: PropTypes.any,
    doSearchingListRes: PropTypes.any,
    getProps: PropTypes.any,
    history: PropTypes.object
};

const mapStateToProps = createStructuredSelector({
    doLoginRes: doLoginRes,
    doRegisterRes: doRegisterRes,
    doMenuCategoryRes: doMenuCategoryRes,
    doCorporateCartListRes: doCorporateCartListRes,
    doProductListingRes: doProductListingRes,
    doCorporateProductRemoveRes: doCorporateProductRemoveRes,
    doProfileDetailsListRes: doProfileDetailsListRes,
    doSearchingListRes: doSearchingListRes
});

function mapDispatchToProps(dispatch) {
    return {
        login_list: (data) => dispatch(login_list(data)),
        createRegister: (data) => dispatch(createRegister(data)),
        menuCategory: (data) => dispatch(menuCategory(data)),
        showCorporateCartList: (data) => dispatch(showCorporateCartList(data)),
        showProductList: (data) => dispatch(showProductList(data)),
        corporateProductRemove: (data) => dispatch(corporateProductRemove(data)),
        showProfile: (data) => dispatch(showProfile(data)),
        searchData: (data) => dispatch(searchData(data)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(withRouter((CorporateLayoutWrapper)));